import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare const Stripe: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  elements: any;
  stripe = Stripe(environment.stripeApiKey);
  @Input() clientSecret: any;
  Loader: boolean = false;
  productTotalPrice: string;

  constructor(private router:Router,
    private modalService: NgbModal) { }

  ngOnInit() {
    const cs = this.clientSecret;
    this.elements = this.stripe.elements({
      clientSecret: cs
    });
    const paymentElement = this.elements.create("payment");
    paymentElement.mount("#payment-element");
    this.productTotalPrice = this.productTotalPrice;
  }

  HandleSubmit(event) {
    this.Loader = true;
    const elements = this.elements;
    this.stripe.confirmPayment({
      elements,
      confirmParams: {
        // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
        return_url: environment.stripeReturnUrl + "?paymentId=" + this.clientSecret,
      },
    })
      .then(function (result) {
      });
  }
  cancel(){
    this.modalService.dismissAll();   
  }
}
